import React from 'react';
import './DealerInformation.scss';

const DealerInformation = ({ dealerInfo }) => {
  const hasAdditionalContact1 = dealerInfo.dealershipContact22?.first || dealerInfo.dealershipContact22?.last;
  const hasAdditionalContact2 = dealerInfo.dealershipContact56?.first || dealerInfo.dealershipContact56?.last;
  const hasAdditionalContact3 = dealerInfo.dealershipContact61?.first || dealerInfo.dealershipContact61?.last;
  const hasAdditionalContact4 = dealerInfo.dealershipContact66?.first || dealerInfo.dealershipContact66?.last;
  const hasAdditionalContact5 = dealerInfo.dealershipContact71?.first || dealerInfo.dealershipContact71?.last;

  return (
    <div className="dealer-info-container">
      <h2>DEALER INFORMATION</h2>
      <div className="info-row">
        <h3>{dealerInfo.dealerCode || 'N/A'}</h3>
      </div>
      <div className="dealer-info-content">
        <div className="info-row">
          <p>{dealerInfo.dealershipName || 'N/A'}</p>
          <p>
            {dealerInfo.dealershipContact?.first && dealerInfo.dealershipContact?.last
              ? `${dealerInfo.dealershipContact.first} ${dealerInfo.dealershipContact.last}`
              : 'N/A'}
          </p>
        </div>
        <div className="info-row">
          <p>{dealerInfo.emailAddress || 'N/A'}</p>
          <p>{dealerInfo.phoneNumber?.full || 'N/A'}</p>
        </div>
        </div>
        <div className="dealer-info-content">
        {/* Add additional contact information if present */}
        {hasAdditionalContact1 && (
          <>
            <div className="info-row additional-contact">
              <p>
                {dealerInfo.dealershipContact22?.first && dealerInfo.dealershipContact22?.last
                  ? `${dealerInfo.dealershipContact22.first} ${dealerInfo.dealershipContact22.last}`
                  : 'N/A'}
              </p>
            </div>
            <div className="info-row">
              <p>{dealerInfo.emailAddress23 || 'N/A'}</p>
              <p>{dealerInfo.phoneNumber24?.full || 'N/A'}</p>
            </div>
          </>
        )}
        </div>
        <div className="dealer-info-content">
        {hasAdditionalContact2 && (
          <>
            <div className="info-row additional-contact">
              <p>
                {dealerInfo.dealershipContact56?.first && dealerInfo.dealershipContact56?.last
                  ? `${dealerInfo.dealershipContact56.first} ${dealerInfo.dealershipContact56.last}`
                  : 'N/A'}
              </p>
            </div>
            <div className="info-row">
              <p>{dealerInfo.emailAddress57 || 'N/A'}</p>
              <p>{dealerInfo.phoneNumber58?.full || 'N/A'}</p>
            </div>
          </>
        )}
        </div>
        <div className="dealer-info-content">
        {hasAdditionalContact3 && (
          <>
            <div className="info-row additional-contact"> 
              <p>
                {dealerInfo.dealershipContact61?.first && dealerInfo.dealershipContact61?.last
                  ? `${dealerInfo.dealershipContact61.first} ${dealerInfo.dealershipContact61.last}`
                  : 'N/A'}
              </p>    
            </div>
            <div className="info-row">
              <p>{dealerInfo.emailAddress62 || 'N/A'}</p>
              <p>{dealerInfo.phoneNumber63?.full || 'N/A'}</p>
            </div>
          </>
        )}    
        </div>
        <div className="dealer-info-content">
        {hasAdditionalContact4 && (
          <>
            <div className="info-row additional-contact"> 
              <p>
                {dealerInfo.dealershipContact66?.first && dealerInfo.dealershipContact66?.last
                  ? `${dealerInfo.dealershipContact66.first} ${dealerInfo.dealershipContact66.last}`
                  : 'N/A'}
              </p>
            </div>
            <div className="info-row">
              <p>{dealerInfo.emailAddress67 || 'N/A'}</p>
              <p>{dealerInfo.phoneNumber68?.full || 'N/A'}</p>
            </div>
          </>
        )}
        </div>
        <div className="dealer-info-content">
        {hasAdditionalContact5 && (
          <>
            <div className="info-row additional-contact"> 
              <p>
                {dealerInfo.dealershipContact71?.first && dealerInfo.dealershipContact71?.last
                  ? `${dealerInfo.dealershipContact71.first} ${dealerInfo.dealershipContact71.last}`
                  : 'N/A'}
              </p>
            </div>
            <div className="info-row">
              <p>{dealerInfo.emailAddress72 || 'N/A'}</p>
              <p>{dealerInfo.phoneNumber73?.full || 'N/A'}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DealerInformation;